import { Alert, AlertDescription } from './ui/alert';

interface PageErrorProps {
  error: string | null | undefined;
}

/** Renders a destructive red Alert when `error` is a non-empty string. */
export function PageError({ error }: PageErrorProps) {
  if (!error) return null;

  return (
    <Alert variant="destructive" className="border-red-200 bg-red-50">
      <AlertDescription className="text-red-700">{error}</AlertDescription>
    </Alert>
  );
}
